module.exports = __webpack_public_path__ + "img/401.88cdad18.svg";